module.exports = __webpack_public_path__ + "static/media/pov_alternative_polytope_3_3_5_cell600.3dfec9c0.png";